import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import MultiRangeSlider from "../../Components/MultiRangeSlider";
const Trade = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content">
          <div className="container px-0">
            {" "}
            <div className="row mx-0">
              <div className="container px-0">
                <div class="row mx-0">
                  <div class="shadowclass top_filters orderpayy mt-4 mb-0">
                    <h4 class="event-alert py-0 my-2">Filters </h4>
                    <div className="row mx-0">
                      <div class="col-lg-4 col-md-6 pl0 px-0 px-sm-3">
                        <div class="calander d-flex align-items-center">
                          <div class="datePicker pading_right">
                            <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                              <input
                                name="from_date"
                                class=" "
                                required="required"
                                type="text"
                                id=""
                                value="2022-05-01"
                              />
                              <span class="add-on">
                                <i class="fa fa-calendar"></i>
                              </span>
                            </div>
                          </div>
                          <div class="datePicker pading_lect">
                            <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                              <input
                                name="to_date"
                                class=" "
                                required="required"
                                type="text"
                                id=""
                                value="2022-05-13"
                              />
                              <span class="add-on">
                                <i class="fa fa-calendar"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-2 col-md-6 timing-duration pt-4 pt-sm-0">
                        <MultiRangeSlider
                          min={0}
                          max={1000}
                          onChange={({ min, max }) =>
                            console.log(`min = ${min}, max = ${max}`)
                          }
                        />

                        {/* <span id="time" className="d-flex justify-content-between"><span className="col">12:00 AM</span> - <span className="col align-right">11:59 PM</span></span>

                    <input
                      type="hidden"
                      name="start_time"
                      value="12:00 AM"
                      class="start_time"
                    />
                    <input
                      type="hidden"
                      name="end_time"
                      value="11:59 PM"
                      class="end_time"
                    />

                    <div
                      id="slider-range"
                      class="ui-slider ui-slider-horizontal ui-widget ui-widget-content ui-corner-all"
                      aria-disabled="false"
                    >
                      <div class="ui-slider-range ui-widget-header ui-corner-all"></div>
                      <a
                        class="ui-slider-handle ui-state-default ui-corner-all"
                        href="#"
                      ></a>
                      <a
                        class="ui-slider-handle ui-state-default ui-corner-all"
                        href="#"
                      ></a>
                    </div> */}
                      </div>
                      <div class="selecters col-lg-5 col-md-10 pl-md-0 row mx-0 justify-content-between pt-0 pt-lg-0">
                        <div class="select-div col px-1 pl-md-0">
                          <div class="input select">
                            <select
                              name="waste_group"
                              class="csutom_select"
                              id="WasteWasteGroup"
                            >
                              <option value="">Waste Group</option>
                              <option value="28">Food R&amp;D</option>
                            </select>
                          </div>{" "}
                        </div>
                        <div class="select-div col px-1">
                          <div class="input select">
                            <select
                              name="waste_type"
                              class="csutom_select"
                              id="WasteWasteType"
                            >
                              <option value="">Waste Type</option>
                              <option value="1">Waste Cost</option>
                              <option value="2">Waste Return</option>
                            </select>
                          </div>{" "}
                        </div>
                        <div class="select-div col px-1">
                          <div class="input select">
                            <select
                              name="supplier"
                              class="csutom_select"
                              id="WasteSupplier"
                            >
                              <option value="">Supplier</option>
                              <option value="6178">6 Drunk Men Pte Ltd</option>
                            </select>
                          </div>{" "}
                        </div>
                      </div>
                      <div class="col-lg-1 col px-0 pt-3 pt-lg-0">
                        <button class="btn btn_btnblue" type="submit">
                          Search
                        </button>
                      </div>
                    </div>
                  </div>{" "}
                </div>
              </div>
            </div>
            <div className="top-header-sec mb-3">
              <div className="col-12 mt-3">
                <div className="row justify-content-end align-items-center">
                  <div className="col-xl-2 align-right">
                    <div className="field text-right">
                      <button
                        class="btn green-btn-revert add-plus addSp mx-0"
                        id="addCount"
                        type="button"
                      >
                        <i class="i-icon"> </i> New Trade Order
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingNine2"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseNine2"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseNine2"
                  >
                    <div className="col d-flex align-items-center justify-content-between">
                      <h4 className="event-alert p-0 mb-0">Saved Orders</h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseNine2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine2"
                >
                  <div className="">
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="col-md-4">
                            <div className="search-box mt-0">
                              <form type="GET">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="submit" />
                              </form>
                            </div>
                          </div>
                          <div className="table-responsive general-setting saved_order_ms">
                            <div className="orderList">
                              <table className="checklist-table remove-space ingredTable">
                                <thead>
                                  <tr>
                                    <th className="min-wd-150">Account</th>
                                    <th>ID</th>
                                    <th>PO #</th>
                                    <th className="min-wd-150">Payee</th>
                                    <th className="min-wd-250"># of Items</th>
                                    <th>Total</th>
                                    <th>Contact</th>

                                    <th>Created</th>
                                    <th>Updated</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody></tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingNine3"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseNine3"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseNine3"
                  >
                    <div className="col d-flex align-items-center justify-content-between">
                      <h4 className="event-alert p-0 mb-0">Order List</h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseNine3"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine3"
                >
                  <div className="">
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="col-md-4">
                            <div className="search-box mt-0">
                              <form type="GET">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="submit" />
                              </form>
                            </div>
                          </div>
                          <div className="table-responsive general-setting saved_order_ms">
                            <div className="orderList">
                              <table className="checklist-table remove-space ingredTable">
                                <thead>
                                  <tr>
                                    <th className="min-wd-150">Account</th>
                                    <th>ID</th>
                                    <th>PO #</th>
                                    <th className="min-wd-150">Payee</th>
                                    <th className="min-wd-250"># of Items</th>
                                    <th>Total</th>
                                    <th className="col-2">Contact</th>
                                    <th>Created</th>
                                    <th>Updated</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr class="order_row">
                                    <td>Boat Quay Pilot</td>
                                    <td>OR000015 </td>

                                    <td>0000001096</td>

                                    <td>
                                      <b>Ngoh Song Trader</b> <br />
                                      ID{" "}
                                    </td>
                                    <td>
                                      <span class="pending">
                                        Orders Pending Approval{" "}
                                      </span>
                                    </td>
                                    <td> $27.86 </td>
                                    <td class="contact-sec-td">TBD@tbd.com</td>
                                    <td>May 05, 2022</td>
                                    <td>May 05, 2022</td>
                                    <td class="action-td">
                                      {" "}
                                      <a
                                        href="/orders/edit/1096"
                                        class="circle_icon"
                                      >
                                        <i class="iconSprites edit-icon">
                                          <div class="tooltip-sm"> Edit </div>{" "}
                                        </i>
                                      </a>{" "}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingNine4"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseNine4"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseNine4"
                  >
                    <div className="col d-flex align-items-center justify-content-between">
                      <h4 className="event-alert p-0 mb-0 d-flex align-items-center">
                        <span class="green-star"></span> Favourite Orders
                      </h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseNine4"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine4"
                >
                  <div className="">
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="col-md-4">
                            <div className="search-box mt-0">
                              <form type="GET">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="submit" />
                              </form>
                            </div>
                          </div>
                          <div className="table-responsive general-setting saved_order_ms">
                            <div className="orderList">
                              <table className="checklist-table remove-space ingredTable">
                                <thead>
                                  <tr>
                                    <th className="min-wd-150">Account</th>
                                    <th className="min-wd-150">Payee</th>
                                    <th>Order Name</th>
                                    <th>Total</th>
                                    <th>Contact</th>
                                    <th>Created</th>
                                    <th>Updated</th>
                                    <th className="action-td">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr class="order_row">
                                    <td>Harry's HQ</td>
                                    <td>
                                      <b>Baker's Oven Pattisieries</b> <br />
                                    </td>
                                    <td>Weekly Poultry </td>
                                    <td>$2,040.00</td>
                                    <td class="contact-sec-td">TBD@tbd.com</td>
                                    <td>Jan 13, 2022</td>
                                    <td>Jan 27, 2022</td>
                                    <td>
                                      <div class="event-time-edit first-td">
                                        <a
                                          href="/orders/editMultiFav/1050"
                                          class="circle_icon"
                                        >
                                          <i class="iconSprites edit-icon">
                                            <div class="tooltip-sm"> Edit </div>{" "}
                                          </i>
                                        </a>
                                        <a href="#_" class="circle_icon">
                                          <i class="sendMultiFav iconSprites send-icon">
                                            {" "}
                                            <div class="tooltip-sm"> Send </div>
                                          </i>
                                        </a>{" "}
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Trade;
